import { Box, ListSubheader, MenuItem } from '@mui/material'
import { CaretDown } from '@phosphor-icons/react'
import { useEffect, useState } from 'react'
import { ClipLoader } from 'react-spinners'
import {
  FormControlStyled,
  InputLabelStyled,
  NormalText,
  SelectStyled,
} from '../styles'
import { Button } from './../button/button'
import { TextFieldStyled } from './../styles'

export const Dropdown = ({
  label,
  defaultValue,
  options,
  isLoading = false,
  onSearch = () => {},
  withSearch = true,
  onSelect,
  placeholder = 'Buscar...',
  required = false,
  width = '100%',
  styles = {},
  withBorder = true,
  withLabel = true,
}) => {
  const [searchText, setSearchText] = useState('')
  const [valueSelected, setValueSelected] = useState(defaultValue || '')

  const handleDelete = () => {
    setSearchText('')
    onSearch('')
    onSelect('')
  }

  const handleChange = (option) => {
    setValueSelected(option?.value)
    if (onSelect) {
      onSelect(option?.value)
    }
  }

  useEffect(() => {
    setValueSelected(defaultValue)
  }, [defaultValue])

  return (
    <FormControlStyled
      withBorder={withBorder}
      width={width}
      sx={{
        '& .MuiOutlinedInput-root': {
          backgroundColor: '#F5F5F5',
        },
        ...styles,
      }}
    >
      {withLabel && valueSelected && (
        <NormalText >{label}</NormalText>
      )}
      {!valueSelected && (
        <InputLabelStyled id={`${label}-select-label`} shrink={false}>
          {label} {required && '*'}
        </InputLabelStyled>
      )}
      <SelectStyled
        MenuProps={{ autoFocus: false, disablePortal: true }}
        labelId={`${label}-select-label`}
        id={`${label}-select`}
        value={valueSelected || defaultValue}
        label={label}
        size="small"
        IconComponent={() => (
          <CaretDown
            size={16}
            weight="regular"
            style={{ pointerEvents: 'none' }}
          />
        )}
      >
        {withSearch && (
          <ListSubheader>
            <Box display={'flex'} gap={'8px'}>
              <TextFieldStyled
                autoFocus
                placeholder={placeholder}
                fullWidth
                onChange={(e) => setSearchText(e.target.value)}
                onKeyUp={(e) => {
                  if (e.key === 'Enter') {
                    onSearch(e.target.value)
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation()
                }}
                value={searchText}
              />
              <Box
                display={'flex'}
                gap={'8px'}
                justifyContent={'flex-end'}
                margin={'8px 0px 0px 0px'}
              >
                <Button label={'Borrar'} onClick={handleDelete} />
                <Button label={'Buscar'} onClick={() => onSearch(searchText)} />
              </Box>
            </Box>
          </ListSubheader>
        )}

        {isLoading ? (
          <Box display="flex" justifyContent="center" p={2}>
            <ClipLoader color={'#0197f6'} size={24} />
          </Box>
        ) : options?.length > 0 ? (
          options?.map((option) => (
            <MenuItem
              key={option?.value}
              value={option?.value}
              onClick={() => handleChange(option)}
              disabled={option?.disabled}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              {option.icon && (
                <img
                  src={option.icon}
                  alt={option.label}
                  style={{
                    width: '16px',
                    height: '16px',
                    borderRadius: '100%',
                  }}
                />
              )}
              {option.label}
            </MenuItem>
          ))
        ) : (
          <Box display={'flex'} justifyContent={'center'}>
            <NormalText>No se encontraron resultados</NormalText>
          </Box>
        )}
      </SelectStyled>
    </FormControlStyled>
  )
}
